var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinancialsFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.92709 11.1993C4.21238 12.2926 3.89571 13.5985 4.03028 14.8978C4.16484 16.197 4.74245 17.4103 5.66606 18.3339C6.58966 19.2576 7.803 19.8352 9.10223 19.9697C10.4015 20.1043 11.7074 19.7876 12.8007 19.0729M13.6006 16.7987C15.2979 16.7987 16.9256 16.1245 18.1257 14.9244C19.3258 13.7243 20 12.0966 20 10.3994C20 8.70215 19.3258 7.07445 18.1257 5.87433C16.9256 4.67422 15.2979 4 13.6006 4C11.9034 4 10.2757 4.67422 9.0756 5.87433C7.87548 7.07445 7.20127 8.70215 7.20127 10.3994C7.20127 12.0966 7.87548 13.7243 9.0756 14.9244C10.2757 16.1245 11.9034 16.7987 13.6006 16.7987Z",
    stroke: "#EE3224",
    strokeWidth: 1.19988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0149 8.96326C14.8421 8.23373 13.9622 7.5754 12.9055 8.06735C11.8488 8.5601 11.6808 10.1455 13.2791 10.3135C14.0014 10.3895 14.4726 10.2255 14.9029 10.6903C15.3349 11.155 15.4149 12.4485 14.3126 12.7973C13.2103 13.146 12.1192 12.6013 12 11.8278M13.587 7.20264V7.89857M13.587 12.9045V13.602",
    stroke: "#EE3224",
    strokeWidth: 1.19988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialsFilter);
export default __webpack_public_path__ + "static/media/FinancialsFilter.62ad3b3d59932433b6f637dbaab68bb9.svg";
export { ForwardRef as ReactComponent };